import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "bg-light-green",
  id: "skill"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row py-5 p-3" }
const _hoisted_4 = { class: "col-12 col-md-4 my-3" }
const _hoisted_5 = { class: "row pb-5 p-3" }
const _hoisted_6 = { class: "col-6 col-md-3 my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillCard = _resolveComponent("SkillCard")!
  const _component_CertiCard = _resolveComponent("CertiCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("SECTION_TITLE.SKILL")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('SKILLS'), (skill) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SkillCard, {
              title: skill.TITLE,
              subTitle: skill.SUBTITLE,
              des: skill.DESCRIPTIONS
            }, null, 8, ["title", "subTitle", "des"])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("SECTION_TITLE.CERTI")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('CERTIS'), (certi) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CertiCard, {
              title: certi.TITLE,
              img: certi.IMG,
              link: certi.LINK
            }, null, 8, ["title", "img", "link"])
          ]))
        }), 256))
      ])
    ])
  ]))
}